import { render } from "./NavPopoverButtons.vue?vue&type=template&id=709a9f27"
import script from "./NavPopoverButtons.vue?vue&type=script&lang=js"
export * from "./NavPopoverButtons.vue?vue&type=script&lang=js"
script.render = render

export default script